import * as EmbedGroup from './EmbedGroup';
export const CONTENT_CREATOR_STOREFRONT = `${EmbedGroup.CONTENT_CREATOR}::storefront`;
export const CONTENT_CREATOR_DETAILS = `${EmbedGroup.CONTENT_CREATOR}::details`;
export const MARKETPLACE_SEARCH_PANEL = `${EmbedGroup.MARKETPLACE_EMBED}::search-panel`;